import React, { useState } from 'react';
import {  useDispatch } from 'react-redux';
import { setUpMovie } from '../../features/movieSlice';
import { useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Carousel from 'react-elastic-carousel';
import ImageChecker from './ImageChecker';
import '../../stylesheet/moviesCurosel.css';
const breakPoints = [
  { width: 1, itemsToShow: 1 },
  { width: 550, itemsToShow: 2, itemsToScroll: 2 },
  { width: 768, itemsToShow: 3 },
  { width: 1200, itemsToShow: 4 },
];

const ModalStyles = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#FFF',
  zIndex: 1000,
  borderRadius: '10px',
};

const overlayStyles = {
  position: 'fixed',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  zIndex: 1000,
};

const closeButtonStyles = {
  position: 'absolute',
  top: '-10px',
  right: '-10px',
  zIndex: 1,
  backgroundColor: '#F150AC',
  color: '#FFFFFF',
  padding: '2px',
  border: 'none',
  borderRadius: '5px',
};

// Memoize the Image component to prevent unnecessary re-renders
const MemoizedImage = React.memo(({ item, index, handlePopupData }) => (
  <div key={item[0]}>
    <ImageChecker imageUrl={item[1]['poster']}>
      <div onClick={() => handlePopupData(index)} style={{ color: 'inherit' }}>
        <Card style={{ width: '16rem', height: '26rem' }}>
          <Card.Img
            style={{
              width: '15rem',
              height: '22rem',
              display: 'block',
              margin: '0 auto',
              borderRadius: '10px',
              paddingTop: '10px',
            }}
            variant='top'
            src={item[1]['poster']}
          />
          <div className='cardtext'>
            <Card.Title >{item[1]['title']}</Card.Title>
            <Card.Text>
              {item[1]['released']
                ? item[1]['released'].split(' ').splice(0, 3).join(' ')
                : <div></div>}
            </Card.Text>
          </div>
        </Card>
      </div>
    </ImageChecker>
  </div>
));

// Memoize the MovieCarousel component
const MoviesCarousel = React.memo(({ data }) => {
  const [KeyIndex, setKeyIndex] = useState(0);
  const [Open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  

  const handlePopupData = (key) => {
    setOpen(true);
    setKeyIndex(key);
  };

  const handleBookTickets = () => {
    const selectedData = data[KeyIndex];
    dispatch(setUpMovie(selectedData));
    navigate('/booking');
    setOpen(false);
  };

  return (
    <div className='Main'>
      <Carousel breakPoints={breakPoints}>
        {data ? (
          Object.entries(data).map((item, index) => (
            item[1]['poster'] && (
              <MemoizedImage key={item[0]} item={item} index={index} handlePopupData={handlePopupData} />
            )
          ))
        ) : (
          <p>Loading data...</p>
        )}
      </Carousel>
      {Open && (
        <div>
          <div style={overlayStyles} />
          <div style={ModalStyles}>
            <Card style={{ width: '18rem' }}>
              <button className='close' onClick={() => setOpen(false)} style={closeButtonStyles}>
                X
              </button>
              <Card.Img variant='top' src={data[KeyIndex]['poster']} style={{ borderRadius: '10px' }} />
              <Card.Body>
                <Card.Title>{data[KeyIndex]['title']}</Card.Title>
                <Card.Text>
                  &#9734; {data[KeyIndex]['imdb']['rating']}/10{' '}
                  {(data[KeyIndex]['imdb']['votes'] / 1000).toFixed(1)} Votes
                </Card.Text>
                <button className='button-1' onClick={handleBookTickets}>
                  Book tickets
                </button>
              </Card.Body>
            </Card>
          </div>
        </div>
      )}
    </div>
  );
});

export default MoviesCarousel;
